export default {
  fullName: {
    id: 'review-best-name',
    defaultMessage: 'That is according to {name}',
  },
}
